<template>
  <div id="topNav">
    <div id="navBar">
      <a id="navBarLogo" href="/"></a>
      <main-menu />
      <user-menu />
      <a id="navBarMenuBtn" href="#" @click="openMenu()">
        <span></span>
        <span></span>
        <span></span>
      </a>
    </div>
    <div id="menu">
      <a href="#" class="close-btn" @click="closeMenu()">
        KAPAT
        <i class="mdi mdi-close"></i>
      </a>
      <div class="box">
        <main-menu />
      </div>
    </div>
    <div id="bgTop"></div>
  </div>
</template>

<script>
import MainMenu from "./MainMenu";
import UserMenu from "./UserMenu";

export default {
  components: {
    MainMenu,
    UserMenu
  },
  methods: {
    openMenu() {
      document.querySelector("body").classList.add("menu-opened");
    },
    closeMenu() {
      document.querySelector("body").classList.remove("menu-opened");
    }
  }
};
</script>

<style lang="scss">
#navBar {
  position: relative;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  //-webkit-transition: all 0.5s cubic-bezier(0.86, 0, 0.07, 1) 0s;
  //transition: all 0.5s cubic-bezier(0.86, 0, 0.07, 1) 0s;

  .menuItems,
  .langs {
    display: none;
  }

  .menuItems {
    a {
      position: relative;
      transition: all 0.3s;
      font-weight: bold;

      &.router-link-active {
        color: $color1;

        &::after {
          content: "";
          position: absolute;
          bottom: -8px;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 50px;
          height: 2px;
          overflow: hidden;
          background-color: $color1;
          opacity: 1;
        }
      }

      &::after {
        content: "";
        position: absolute;
        bottom: -8px;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 0;
        height: 2px;
        overflow: hidden;
        background-color: $color1;
        opacity: 0;
        transition: all 0.3s;
      }

      &:hover::after {
        opacity: 1;
        width: 50px;
      }
    }
  }

  #navBarLogo {
    position: relative;
    top: 15px;
    display: block;
    width: 160px;
    height: 70px;
    background-image: url("../../assets/img/utex-logo.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: left center;
    margin-left: 15px;
    margin-right: auto;
  }

  #navBarMenuBtn {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-flow: column nowrap;
    flex-flow: column nowrap;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    width: 30px;
    height: 21px;
    margin-right: 15px;
    margin-top: 7px;

    span {
      display: block;
      width: 100%;
      height: 3px;
      background: linear-gradient(135.44deg, #7101d0 10.28%, #b94ced 89.18%);
      overflow: hidden;

      &:nth-child(2) {
        width: 80%;
        background: linear-gradient(135.44deg, #9c247a 10.28%, #db0ea1 89.18%);
      }

      &:nth-child(3) {
        width: 60%;
      }
    }

    &:hover {
      text-decoration: none;
    }
  }

  @media #{map-get($display-breakpoints, "md-and-up")} {
    width: 874px;
    margin: 10px auto 0;

    #navBarLogo {
      margin-left: 0;
    }

    #navBarMenuBtn {
      display: none;
      margin-left: 0;
    }

    .menuItems {
      padding: 0;
      margin: 0;
      display: flex;
      list-style: none;

      li {
        margin: 0;
        padding: 0 15px;
        float: left;

        &:last-child {
          margin-right: 15px;
        }

        a {
          color: #000;
          font-size: 14px;
          letter-spacing: 0.1rem;
          text-decoration: none;

          &:hover {
            color: $color1;
          }
        }
      }
    }
  }

  @media #{map-get($display-breakpoints, "lg-and-up")} {
    width: 1165px;
  }

  @media #{map-get($display-breakpoints, "xl-only")} {
    width: 1737px + 24px;
  }
}

// Menu
#menu {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: $color1;
  z-index: 999;
  visibility: hidden;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
  -webkit-transition: all 0.5s cubic-bezier(0.86, 0, 0.07, 1) 0s;
  transition: all 0.5s cubic-bezier(0.86, 0, 0.07, 1) 0s;

  // Close Button
  .close-btn {
    display: block;
    width: 100px;
    position: absolute;
    top: -40px;
    right: 0;
    font-size: 0.6rem;
    text-decoration: none;
    color: #fff;
    letter-spacing: 0.2rem;
    text-align: center;
    line-height: normal;
    -webkit-transition: all 0.3s cubic-bezier(0.86, 0, 0.07, 1) 0.3s;
    transition: all 0.3s cubic-bezier(0.86, 0, 0.07, 1) 0.3s;

    &:hover {
      text-decoration: none;
      color: #fff;
      opacity: 0.75;
    }

    i {
      font-size: 1.4rem;
      position: relative;
      top: 0.29rem;
    }
  }

  .box {
    position: absolute;
    width: 60%;
    height: 60%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto auto;
    background-color: rgba(0, 0, 0, 0.05);
  }

  .menuItems {
    width: 100%;
    height: 100%;
    list-style: none;
    padding: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    font-size: 1rem;
    letter-spacing: 0.1rem;
    background-color: transparent;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;

    li {
      position: relative;
      left: -80px;
      margin: 15px 0;
      opacity: 0;

      -webkit-transition: all 0.5s cubic-bezier(0.86, 0, 0.07, 1) 0.3s;
      transition: all 0.5s cubic-bezier(0.86, 0, 0.07, 1) 0.3s;

      @for $i from 1 to 10 {
        &:nth-of-type(#{$i}) {
          -webkit-transition-delay: 0.05s * $i;
          transition-delay: 0.05s * $i;
        }
      }
    }

    a {
      position: relative;
      color: #fff;
      text-decoration: none;
      -webkit-transition: all 0.2s ease;
      transition: all 0.2s ease;
      font-size: 1.4rem;
      letter-spacing: 0.2rem;

      &:before {
        content: "";
        position: absolute;
        width: 100%;
        height: 1px;
        bottom: -3px;
        left: 0;
        background-color: #fff;
        visibility: hidden;
        opacity: 0;
        -webkit-transform: translate3d(-100%, 0, 0);
        transform: translate3d(-100%, 0, 0);
        -webkit-transition: all 0.3s ease;
        transition: all 0.3s ease;
      }

      &:hover {
        color: #fff;
        -webkit-transition: all 0.3s ease;
        transition: all 0.3s ease;
        opacity: 0.75;

        &:hover:before {
          visibility: visible;
          opacity: 1;
          -webkit-transform: translate3d(0, 0, 0);
          transform: translate3d(0, 0, 0);
        }
      }
    }

    @media #{map-get($display-breakpoints, "lg-and-up")} {
      font-size: 1.8rem;
    }
  }
}

// Ana menü
//****************************/
.menu-opened {
  #menu {
    visibility: visible;
    -webkit-transform: translateX(0);
    transform: translateX(0);

    .close-btn {
      top: 10px;
    }

    .menuItems li {
      left: -40px;
      opacity: 1;
    }
  }
}
</style>
